import murmur from 'murmurhash3js'

export const SEARCH_TYPES = {
    TERM: 'term',
    ADV_TERM: 'adv_term',
    FILTER: 'filter',
    FUND_FILTER: 'fund-filter',
    RANGE_YEAR_FILTER: 'range-year-filter',
}

export function newTerm(value) {
    return {
        type: SEARCH_TYPES.TERM,
        id: murmur.x86.hash32(value),
        value: value
    }
}

export function newAdvTerm(label, field, value) {
    return {
        type: SEARCH_TYPES.ADV_TERM,
        id: murmur.x86.hash32(`${field}${value}`),
        field: field,
        label: label,
        value: value
    }
}

export function newFilter(fq, switchFor) {
    const data = {
        type: SEARCH_TYPES.FILTER,
        id: murmur.x86.hash32(fq),
        fq: fq
    };

    if(switchFor)
        data["switch"] = switchFor;

    return data;
}

export function newFundFilter(id) {
    return {
        type: SEARCH_TYPES.FUND_FILTER,
        id: murmur.x86.hash32(id),
        fq: id === 'all' ? '' : `hier_id_ss: ${id}`
    }
}

export function newRangeYearFilter(min, max) {
    const fq = `(year_start_i:[* TO ${max}] AND year_end_i:[${min} TO *]) OR (*:* NOT year_start_i:[* TO *])`;

    return {
        type: SEARCH_TYPES.RANGE_YEAR_FILTER,
        id: murmur.x86.hash32(fq),
        fq: fq,
        value: [min, max]
    }
}

export function newTag(id, label) {
    return {
        id: id,
        label: label,
    }
}
